
export const userDisplayName = (user) => {
  if (user.nickname) {
    return `${user.nickname}`;
  }
  if (user.first_name) {
    return `${user.first_name} ${`${user.last_name[0]}.` || ''}`;
  }
  return user.email;
};
export const userFullName = (user) => {
  if (user.first_name) {
    return `${user.first_name} ${user.last_name}`;
  }
  return user.email;
};
